import React from "react";
import OurServices from "./OurServices";
import useScrollFadeIn from "./hooks/useScrollFadeIn";
import senthilPassport from './Images/web-self.jpg';

function About() {
  const fadeInTitle = useScrollFadeIn("fade-in", 0.1);
  const fadeInSubtitle = useScrollFadeIn("fade-in-right", 0.3);
  const fadeInSection1 = useScrollFadeIn("fade-in", 0.2);
  const fadeInSection2 = useScrollFadeIn("fade-in", 0.4);
  const fadeInLegacy = useScrollFadeIn("fade-in", 0.6);
  const fadeInTrustTitle = useScrollFadeIn("fade-in", 0.8);
  const fadeInTrustList = useScrollFadeIn("fade-in-right", 1);

  return (
    <div className="about-comp" style={{ backgroundColor:'rgba(30, 29, 64, 0.5)', height:'100%', padding: "40px" }}>
      {/* Page Title */}
      <h1 ref={fadeInTitle} style={{ textAlign: "center", marginBottom: "10px" }}>
        About Acharya Senthilkumar
      </h1>
      <h3 ref={fadeInSubtitle} style={{ textAlign: "center", fontStyle: "italic", color: "#555" }}>
        Guiding Your Path with Celestial Wisdom
      </h3>

      {/* Newspaper column format with image */}
      <section
        ref={fadeInSection1}
        className="about-newspaper"
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "32px",
          maxWidth: "1150px",
          margin: "0 auto",
          lineHeight: "1.8",
          background: "rgba(0,0,0,0.05)",
          borderRadius: "12px",
          padding: "24px"
        }}
      >
        <img
          src={senthilPassport}
          alt="Senthil Kumar Passport"
          style={{
            width: "180px",
            height: "220px",
            objectFit: "cover",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            flexShrink: 0
          }}
        />
        <div style={{ flex: 1, textAlign: "left" }}>
          <p>
            <strong>Vanakkam and Welcome.</strong> My name is <strong>Acharya
            Senthilkumar</strong> , and I am a Vedic and Nadi astrologer, teacher, and
            author based in Chennai, dedicated to bridging the ancient wisdom of
            the cosmos with the practicalities of modern life. 
            For over <strong>15 years</strong>, my purpose has been to demystify
            the language of the stars.I believe that astrology is not about
            fortune-telling, it is a divine science that empowers us with
            self-awareness and guides us toward a more fulfilling destiny. 
          </p>
          <p>
            My journey has been one of immense privilege, having analyzed over{" "}
            <strong>12,000 horoscopes</strong> and mentored more than{" "}
            <strong>5,000 students</strong>. While I am based in Tamil Nadu, my
            community of clients and students spans the globe — from India to the
            USA, UK, Germany, Singapore, and beyond.
          </p>
        </div>
      </section>

      {/* Journey & Philosophy */}
      <section ref={fadeInSection2} style={{maxWidth:'950px',textAlign:'center',margin:'0 auto' }}>
        <h2>My Journey & Philosophy</h2>
        <p>
          My fascination with astrology began with a single, profound question:
          <em> How do the celestial patterns above mirror the human experience
          below?</em> This curiosity blossomed into years of rigorous study,
          deep research, and dedicated practice.
        </p>
        <p>
          My philosophy is simple: astrology should be{" "}
          <strong>simple, practical, and accurate</strong>. I have devoted my
          work to uncovering and refining the core principles of Vedic
          astrology, developing unique techniques that provide clear, precise,
          and actionable insights.
        </p>
      </section>

      {/* Legacy */}
      <section ref={fadeInLegacy} style={{ margin: "10px auto" }}>
        <h2 style={{textAlign:'center'}}>A Legacy of Knowledge & Innovation</h2>
        <ul className="about-flex-list">
          <li style={{fontWeight:700}}>Life Span Analysis</li>
          <li style={{fontWeight:700}}>Childbirth Predictions</li>
          <li style={{fontWeight:700}}>Financial Astrology</li>
          <li style={{fontWeight:700}}>Relationship Compatibility</li>
          <li style={{fontWeight:700}}>Astrological Remedies</li>
        </ul>
      </section>

      {/* Trust Section */}
      <section style={{maxWidth:'950px',margin: "10px auto" }}>
        <h2 ref={fadeInTrustTitle} style={{textAlign:'center'}}>Why Trust Acharya Senthilkumar?</h2>
        <ul ref={fadeInTrustList} className="about-flex-list trust-list">
          <li style={{fontWeight:700}}>15+ Years of Astrological Practice</li>
          <li style={{fontWeight:700}} >8+ Years of Teaching Experience</li>
          <li style={{fontWeight:700}}>5,000+ Students Trained</li>
          <li style={{fontWeight:700}}>12,000+ Horoscopes Analyzed</li>
          <li style={{fontWeight:700}}>Clients across 7+ countries</li>
          <li style={{fontWeight:700}}>Author of 4 astrology books in Tamil</li>
        </ul>
      </section>
    </div>
  );
}

export default About;
